const _ = require('lodash');
const Logger = require('./Logger');

module.exports = class LoggerFactory {
	constructor () {
		this.loggers = [];
	}

	getLogger (contextName) {
		let logger = _.find(this.loggers, (logger) => {
			return logger.getContextName() === contextName;
		});

		if (_.isEmpty(logger)) {
			logger = new Logger(contextName);
			this.loggers.push(logger);
		}

		return logger;
	}
}